import React from "react";

export class TBody extends React.Component<any, any> {
    public static index: number = 0;

    render() {
        let index = TBody.index + 1;
        TBody.index += this.props.data.length;
        return (
            <tbody key={'rowI' + index}>
            {this.props.data.map(function (items: any) {
                if ((items[1] || null) === '{{skip-row}}' || (items[0] || null) === '{{skip-row}}') {
                    return '';
                }
                TBody.index += items.length;
                index++;
                return (
                    <tr key={'rowI' + index}>
                        {items.map(function (item: any) {
                            index++;
                            if (React.isValidElement(item) && (item.type === "td" || item.type === "th")) {
                                return item;
                            }
                            return (<td key={'rowJ' + index}>{item}</td>);
                        })}
                    </tr>
                )
            })}
            </tbody>
        );
    }
}
